export const getMediaBackdropUrl = media => {
    if (media?.kind === 'image') return media?.src || null
    if (media?.kind === 'image-audio') return media?.imageSrc || null
    if (media?.kind === 'video') return media?.poster || null

    return (
        media?.file?.preview_urls?.['1x1'] ||
        media?.file?.preview_url ||
        media?.file?.preview_urls?.original ||
        null
    )
}

export const stripEmbeddedLinksFromCaption = (caption, extractedUrls) => {
    if (!caption) return ''

    let nextCaption = caption
    const urlsToRemove = [
        ...(extractedUrls?.knovEmbedLinks || []),
        ...(extractedUrls?.streamEmbedLinks || []),
    ].filter(Boolean)

    urlsToRemove.forEach(url => {
        nextCaption = nextCaption.split(url).join('')
    })

    return nextCaption.replace(/\n{3,}/g, '\n\n').trim()
}

export const getTrackedMediaKind = (mediaKind, trackedEmbedMediaKind = null) => {
    if (mediaKind === 'audio' || mediaKind === 'image-audio' || mediaKind === 'video') {
        return mediaKind
    }

    if (mediaKind !== 'text') return null

    return trackedEmbedMediaKind || null
}

export const isTrackedAudioMediaKind = trackedMediaKind =>
    trackedMediaKind === 'audio' || trackedMediaKind === 'image-audio'

export const getStoryControlResumeToken = playbackCommand =>
    playbackCommand?.action === 'play' && playbackCommand?.source === 'story-control'
        ? playbackCommand.sequence
        : null

export const getTrackedAudioResumePlaybackToken = (
    trackedMediaKind,
    trackedAudioPlayRequestToken,
    storyControlResumeToken,
) =>
    isTrackedAudioMediaKind(trackedMediaKind)
        ? trackedAudioPlayRequestToken || storyControlResumeToken
        : null

export const getReactionPickerOpenBehavior = isPaused => {
    const shouldPausePlayback = !isPaused

    return {
        shouldPausePlayback,
        reactionPickerPausedPlayback: shouldPausePlayback,
    }
}

export const getReactionPickerCloseBehavior = reactionPickerPausedPlayback => ({
    shouldResumePlayback: Boolean(reactionPickerPausedPlayback),
    reactionPickerPausedPlayback: false,
})
